module.exports = __webpack_public_path__ + "static/img/jmt.6f468e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/jmt.png
// module id = lw0c
// module chunks = 44